import { useMutation, type MutationHookOptions } from "@apollo/client"
import mutation from "@/v2-backoffice-client/invitation/update/invitation.update.mutation.gql"
import type {
  InvitationUpdateMutation,
  InvitationUpdateMutationVariables,
} from "@/v2-backoffice-client/invitation/update/__types__/invitation.update.mutation"

type Options = MutationHookOptions<
  InvitationUpdateMutation,
  InvitationUpdateMutationVariables
>

export function useInvitationUpdateMutation(options?: Options) {
  return useMutation<
    InvitationUpdateMutation,
    InvitationUpdateMutationVariables
  >(mutation, options)
}
